import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var courseQuizRes;
export const courseQuizTodo = createAsyncThunk('courseQuiz', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/get_course_quiz',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "quiz_id": val.quiz_id,
                "course_id": val.course_id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return courseQuizRes = res.data
    } catch (error) {
        return courseQuizRes = error.response.data
    }
})


const courseQuizSlice = createSlice({
    name: 'courseQuiz',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(courseQuizTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('courseQuiz', state.data)
            }
        });
        builder.addCase(courseQuizTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default courseQuizSlice.reducer; 